module.exports = __webpack_public_path__ + "fonts/Lyon Arabic Display Medium.b95c23e.otf";